<template>
  <div class="mdc-data-table">
    <div class="mdc-data-table__table-container">
      <table class="mdc-data-table__table" aria-label="Sector stocks">
        <thead>
          <tr class="mdc-data-table__header-row">
            <th class="mdc-data-table__header-cell" role="columnheader" scope="col" aria-sort="none">Sectores</th>
            <th class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort" role="columnheader" scope="col" aria-sort="none" data-column-id="m1">
            <div class="mdc-data-table__header-cell-wrapper">
                <button class="mdc-icon-button material-icons mdc-data-table__sort-icon-button" aria-label="Sort by 1 mounth" aria-describedby="protein-status-label">arrow_upward</button>
                <div class="mdc-data-table__header-cell-label">Un més</div>
                <div class="mdc-data-table__sort-status-label" aria-hidden="true" id="protein-status-label"></div>
            </div>
            </th>
            <th class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort" role="columnheader" scope="col" aria-sort="none" data-column-id="m3">
            <div class="mdc-data-table__header-cell-wrapper">
                <button class="mdc-icon-button material-icons mdc-data-table__sort-icon-button" aria-label="Sort by 3 mounth" aria-describedby="protein-status-label">arrow_upward</button>
                <div class="mdc-data-table__header-cell-label">3 Meses</div>
                <div class="mdc-data-table__sort-status-label" aria-hidden="true" id="protein-status-label"></div>
            </div>
            </th>
            <th class="mdc-data-table__header-cell mdc-data-table__header-cell--numeric mdc-data-table__header-cell--with-sort mdc-data-table__header-cell--sorted" role="columnheader" scope="col" aria-sort="ascending" data-column-id="y1">
            <div class="mdc-data-table__header-cell-wrapper">
                <button class="mdc-icon-button material-icons mdc-data-table__sort-icon-button" aria-label="Sort by 1 year" aria-describedby="carbs-status-label">arrow_upward</button>
                <div class="mdc-data-table__header-cell-label">1 Año</div>
                <div class="mdc-data-table__sort-status-label" aria-hidden="true" id="carbs-status-label"></div>
            </div>
            </th>
            <th class="mdc-data-table__header-cell" role="columnheader" scope="col"  data-column-id="amount">Valores eurekers</th>
            <th class="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="options">Opciones</th>
          </tr>
        </thead>
        <tbody class="mdc-data-table__content">
          <tr class="mdc-data-table__row" v-for="(sector, index) in _orderTableSector" :key="index">
            <td class="mdc-data-table__cell sector-name">
              <p><strong>{{ sector.name }}</strong></p>
              <span>{{ Object.keys(sector.sub_sector).length }} Industrias</span></td>
            
            <td class="mdc-data-table__cell mdc-data-table__cell--numeric one-mount">{{sector.m1}}</td>
            <td class="mdc-data-table__cell mdc-data-table__cell--numeric three-month">{{sector.m3}}</td>
            <td class="mdc-data-table__cell mdc-data-table__cell--numeric one-year">{{sector.y1}}</td>

            <td class="mdc-data-table__cell mdc-data-table__cell--numeric eurekers-values">
              {{eurekers_values[sector.name]}}</td>

            <td class="mdc-data-table__cell options">
              <i @click.prevent="_userPermissionShowStockchart(sector.name)" class="material-icons mdc-button__icon" aria-hidden="true">show_chart</i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



<script>
import { MDCDataTable } from '@material/data-table';
import _ from 'lodash';

export default {
  name: 'TableSector',
  props: {
    sectors_table_data: Array,
    eurekers_values: Object,
  },
  data: () => ({
    sort: {
      column: 'm1',
      order: 'asc'
    }
  }),
  mounted() {
    const _tableSectorComponent =  new MDCDataTable(document.querySelector('.mdc-data-table'));
      
    _tableSectorComponent.listen('MDCDataTable:sorted', (event) => {
      this.sort.order = (event.detail.sortValue == "ascending") ? "asc" : 'desc';
      this.sort.column = event.detail.columnId;
    });
  },
  computed: {
    _orderTableSector() {
      return _.orderBy(this.sectors_table_data, this.sort.column, this.sort.order);
    }
  },
  methods: {
    _userPermissionShowStockchart(sector) {
      this.$router.push('/app/graficador-dinamico/sector/' + sector);
    },
  },
}
</script>



<style lang="scss" scoped>
  @use "@material/checkbox"; 
  @use "@material/icon-button"; 
  @use "@material/data-table/data-table";

  @include checkbox.core-styles;
  @include icon-button.core-styles;
  @include data-table.core-styles;
  @include data-table.theme-baseline;

  $color_dark: var(--color-text-primary);
  $back_white: var(--color-surface);
  $back_light_grey: var(--color-muted);
  $highlight_color: var(--color-active-surface); // Replace with your desired hover color

  .mdc-data-table__header-cell {
    text-transform: uppercase;
    background-color: $back_light_grey;}
  .mdc-data-table__header-cell,
  .mdc-data-table__cell {
    color: $color_dark;
    font-size: 12px;
    letter-spacing: 1px;
    text-align: center;}
  .mdc-data-table__row {
    background-color: $back_white;

    &:hover {
      background-color: var(--color-background) !important;
      cursor: pointer;
    }
  }
  .index-content {
    display: flex;
    justify-content: center;
    flex-direction: column;}
  p {
    margin: 0;}
  .mdc-data-table {
    margin-bottom: 40px;
    width: 100%;}
  .options {
    cursor: pointer;
  }
</style>
